(function () {
  'use strict';

  const popup = document.getElementById('grusskarten-popup');
  if (!popup) return;

  // Übersetzte Strings aus Liquid via data-Attribute (locales/{en,de}.json)
  const i18n = {
    adding: popup.dataset.i18nAdding || 'Adding…',
    errorPrefix: popup.dataset.i18nErrorPrefix || 'The card could not be added:',
    unknownError: popup.dataset.i18nUnknownError || 'Unknown error',
    propertyName: popup.dataset.i18nPropertyName || 'Gift message',
    addButton: popup.dataset.i18nAddButton || 'Continue to checkout',
    addButtonWithCardsOne:
      popup.dataset.i18nAddButtonWithCardsOne || 'Checkout with card',
    addButtonWithCardsOther:
      popup.dataset.i18nAddButtonWithCardsOther || 'Checkout with cards'
  };

  const checkoutSelectors = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    'a[href="/checkout"]',
    'a[href^="/checkout?"]'
  ].join(',');

  let popupAnswered = false;
  let pendingHref = null;
  let submitInFlight = false;

  // Checkout-Klick-Interception
  document.addEventListener(
    'click',
    function (e) {
      if (popupAnswered) return;
      if (window.location.pathname.indexOf('/checkout') === 0) return;

      const target = e.target.closest(checkoutSelectors);
      if (!target) return;

      e.preventDefault();
      e.stopPropagation();

      pendingHref = target.tagName === 'A' ? target.getAttribute('href') : null;

      openPopup();
    },
    true
  );

  function openPopup() {
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('grusskarten-popup-open');
    updateAddButton();
  }

  function closePopupVisual() {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('grusskarten-popup-open');
  }

  function proceedToCheckout() {
    if (popupAnswered) return;
    popupAnswered = true;
    closePopupVisual();

    if (pendingHref) {
      window.location.href = pendingHref;
      return;
    }

    // Frische Form bauen und POST /cart mit checkout=1 absetzen — exakt das,
    // was der native Button-Submit tut.
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = '/cart';
    form.style.display = 'none';

    const checkoutInput = document.createElement('input');
    checkoutInput.type = 'hidden';
    checkoutInput.name = 'checkout';
    checkoutInput.value = '';
    form.appendChild(checkoutInput);

    document.body.appendChild(form);
    form.submit();
  }

  // X-Button und Overlay-Klick: zur Kasse (ohne Karte)
  popup.querySelectorAll('[data-grusskarten-close]').forEach(function (el) {
    el.addEventListener('click', function () {
      if (submitInFlight) return;
      proceedToCheckout();
    });
  });

  // Escape: zur Kasse (ohne Karte)
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popup.classList.contains('is-open') && !submitInFlight) {
      proceedToCheckout();
    }
  });

  // -------------------------------------------------------------------------
  // Checkbox-Logik + dynamisches Button-Label
  // -------------------------------------------------------------------------
  const cardCheckboxes = popup.querySelectorAll('.grusskarten-card__checkbox');
  const addBtn = popup.querySelector('[data-grusskarten-add]');

  function getCheckedCount() {
    return popup.querySelectorAll('.grusskarten-card__checkbox:checked').length;
  }

  function updateAddButton() {
    if (!addBtn) return;
    const count = getCheckedCount();
    if (count === 0) {
      addBtn.textContent = i18n.addButton;
    } else if (count === 1) {
      addBtn.textContent = i18n.addButtonWithCardsOne;
    } else {
      addBtn.textContent = i18n.addButtonWithCardsOther;
    }
  }

  cardCheckboxes.forEach(function (cb) {
    // aria-pressed für Barrierefreiheit
    const label = cb.closest('.grusskarten-card');
    if (label) {
      label.setAttribute('role', 'checkbox');
      label.setAttribute('aria-checked', cb.checked ? 'true' : 'false');
      label.setAttribute('tabindex', '0');
    }

    cb.addEventListener('change', function () {
      const variantId = cb.value;
      const msgItem = popup.querySelector('[data-msg-for="' + variantId + '"]');
      if (msgItem) {
        msgItem.hidden = !cb.checked;
        if (cb.checked) {
          const ta = msgItem.querySelector('textarea');
          if (ta) {
            // Kurze Verzögerung, damit das Element sichtbar ist bevor Fokus wandert
            setTimeout(function () { ta.focus(); }, 50);
          }
        }
      }
      if (label) {
        label.setAttribute('aria-checked', cb.checked ? 'true' : 'false');
      }
      updateAddButton();
    });
  });

  // Character-Counter pro Textarea
  popup.querySelectorAll('.grusskarten-message-item textarea').forEach(function (ta) {
    const variantId = ta.dataset.variantId;
    const counter = popup.querySelector('[data-counter-for="' + variantId + '"]');
    if (!counter) return;
    ta.addEventListener('input', function () {
      counter.textContent = String(ta.value.length);
    });
  });

  // -------------------------------------------------------------------------
  // Haupt-Button-Klick: 0 Karten → direkt zur Kasse; ≥1 Karte → AJAX + Kasse
  // -------------------------------------------------------------------------
  if (addBtn) {
    addBtn.addEventListener('click', function () {
      if (submitInFlight) return;

      const checked = popup.querySelectorAll('.grusskarten-card__checkbox:checked');

      // 0 Karten → direkt zur Kasse ohne AJAX
      if (checked.length === 0) {
        proceedToCheckout();
        return;
      }

      // ≥1 Karte(n) → AJAX, dann Kasse
      const items = [];
      checked.forEach(function (cb) {
        const variantId = parseInt(cb.value, 10);
        const ta = popup.querySelector('textarea[data-variant-id="' + cb.value + '"]');
        const message = ta ? (ta.value || '').trim() : '';
        const properties = {};
        if (message) properties[i18n.propertyName] = message;
        items.push({ id: variantId, quantity: 1, properties: properties });
      });

      submitInFlight = true;
      const originalLabel = addBtn.textContent;
      addBtn.textContent = i18n.adding;
      addBtn.setAttribute('aria-busy', 'true');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (data) {
              throw new Error(data.description || i18n.unknownError);
            });
          }
          return res.json();
        })
        .then(function () {
          proceedToCheckout();
        })
        .catch(function (err) {
          console.error('[Grußkarten-Popup]', err);
          submitInFlight = false;
          addBtn.removeAttribute('aria-busy');
          addBtn.textContent = originalLabel;
          alert(
            i18n.errorPrefix +
              '\n' +
              (err && err.message ? err.message : i18n.unknownError)
          );
        });
    });
  }

  // Keyboard-Aktivierung der Karten (Space/Enter)
  cardCheckboxes.forEach(function (cb) {
    const label = cb.closest('.grusskarten-card');
    if (!label) return;
    label.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault();
        cb.checked = !cb.checked;
        cb.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });
})();
